module.exports = __webpack_public_path__ + "static/media/wf_symbol.c0a2c23d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/wf_symbol.png
// module id = 385
// module chunks = 0